import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtil } from '../utils/http-util';
import {
  GetCatalogItem,
  AddCatalogItem,
  GetCatalogItemVersion,
  AddCatalogItemVersion,
  AddCatalogItemMedia,
  AddCatalogItemBenefit,
  AddCatalogItemPlan,
  AddCatalogItemCapacity,
  AddCatalogBundle,
  GetCatalogVersionBundle,
  GetVersionDiff,
  DuplicateCatalogVersion,
  DuplicateCatalogVersionResult
} from '../models/catalogs/catalog';
import { Paged } from '../models/shared/paged';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CatalogItemService {
  private http = inject(HttpClient);
  private apiBaseUrl = environment.api.url;
  private base = `${this.apiBaseUrl}/Catalog`;

  getCatalogItems(filter?: any): Observable<Paged<GetCatalogItem>> {
    return this.http.get<Paged<GetCatalogItem>>(this.base, {
      params: HttpUtil.toHttpParams(filter)
    });
  }

  getCatalogItemById(catalogItemId: number): Observable<GetCatalogItem> {
    return this.http.get<GetCatalogItem>(`${this.base}/${catalogItemId}`);
  }

  getCatalogVersionBundle(versionId: number) {
    return this.http.get<GetCatalogVersionBundle>(`${this.base}/bundle/${versionId}`);
  }

  deleteCatalogItem(itemId: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${itemId}`);
  }

  getCatalogItemVersions(itemId: number, options?: { page: number, pageSize: number, FilterKey?: string, filterValue?: string, versionId?: number; versionNumber?: number, statusCode?: string }): Observable<Paged<GetCatalogItemVersion>> {
    return this.http.get<Paged<GetCatalogItemVersion>>(`${this.base}/versions/${itemId}`, {
      params: HttpUtil.toHttpParams(options ?? {})
    });
  }

  getCatalogItemVersionById(versionId: number): Observable<GetCatalogItemVersion> {
    return this.http.get<GetCatalogItemVersion>(`${this.base}/version/${versionId}`);
  }

  addCatalogBundle(bundle: AddCatalogBundle): Observable<number> {
    return this.http.post<number>(`${this.base}/bundle`, bundle);
  }

  publishCatalogItemVersion(catalogItemId: number, versionId: number) {
    return this.http.post<void>(`${this.base}/${catalogItemId}/publish/${versionId}`, {});
  }

  retireCatalogItemVersion(catalogItemId: number, versionId: number) {
    return this.http.post<void>(`${this.base}/${catalogItemId}/retire/${versionId}`, {});
  }

  getVersionDiffs(catalogItemId: number, versionId: number): Observable<GetVersionDiff[]> {
    return this.http.get<GetVersionDiff[]>(`${this.base}/${catalogItemId}/versions/${versionId}/diffs`);
  }

  duplicateCatalogVersion(duplicateCatalogVersion: DuplicateCatalogVersion): Observable<DuplicateCatalogVersionResult> {
    return this.http.post<DuplicateCatalogVersionResult>(`${this.base}/duplicate`, duplicateCatalogVersion);
  }
}